import Component from "@glimmer/component";
import { htmlSafe } from "@ember/template";
import { Marked, Renderer } from "marked";

const marked = new Marked();
const defaultLink = Renderer.prototype.link;
marked.use({
  renderer: {
    link(token) {
      const html = defaultLink.call(this, token);
      if (token.href.startsWith("mailto:")) {
        return html;
      }
      return html.replace(/^<a /, '<a target="_blank" rel="noopener noreferrer" ');
    },
  },
});

export default class MarkdownToHtml extends Component {
  get html() {
    return htmlSafe(marked.parse(this.args.markdown ?? ""));
  }

  <template>{{this.html}}</template>
}
